'use client';
import Link from 'next/link';
import { Flex, Heading, Icon, Tooltip } from 'politicamente-informados-ds';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { gradientAnimation } from '../Header/Header.theme';

const MaletaButton = ({ mainMenu = false }) => {
    const [isLight, setIsLight] = useState(false);

    useEffect(() => {
        if (mainMenu)
            setIsLight(!!document.querySelectorAll('.style-light').length);
    });

    return (
        <Container>
            <Flex gap="8px">
                <Link
                    target="_blank"
                    href={
                        'https://matosinhosjovem.pt/todos-os-projetos/maleta-pedagogica-politicamente-informados/'
                    }>
                    <Flex gap="8px" wrap="wrap">
                        <Heading
                            size="captions"
                            tag="p"
                            className="fw-semibold">
                            💼
                        </Heading>
                        <Heading
                            size="captions"
                            tag="span"
                            className="fw-semibold gradient-hover">
                            Maleta Pedagógica
                        </Heading>
                    </Flex>
                </Link>
                <Tooltip
                    theme={isLight ? 'light' : 'dark'}
                    tooltipText={
                        'Coleção de recursos educacionais para auxiliar professores, com materiais didáticos, planos de aula e atividades práticas.'
                    }>
                    <Icon icon="icon-info" style={{ fontSize: '10px' }} />
                </Tooltip>
            </Flex>
        </Container>
    );
};

export default MaletaButton;

const Container = styled.div`
    .gradient-hover:hover {
        transition: all 300ms;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(
            90deg,
            var(--color-primary50),
            var(--color-secondary50)
        );
        animation: ${gradientAnimation} 1s ease;
        background-size: 150% 150%;
    }
`;
